module.exports = __webpack_public_path__ + "static/media/Certificate for Guru Of The Day_my_portfolio_30-11-2021.c80d4541.pdf";